import _ from 'lodash'
import { getAdmin } from '../AdminById/selectors'
import { getUser } from '../UserById/selectors'
import { Admin, State, User } from '../../types'

export const getAuth = (state: State) => state.Auth
export const getLoading = (state: State) => state.Auth.loading
export const getLoginUser = (state: State): User | null => {
  if (state.Auth.loading || !state.Auth.authorized) {
    console.warn('not login')
    return null
  }
  return getUser(state, state.Auth.userId)
}

export const getLoginAdmin = (state: State): Admin | null => {
  if (state.Auth.loading || !state.Auth.authorized) {
    console.warn('not login')
    return null
  }
  return getAdmin(state, state.Auth.userId)
}

export const getLoginUserAdmin = (state: State): User | Admin | null => {
  try {
    return getLoginUser(state) || getLoginAdmin(state)
  } catch (e) {
    console.warn(e)
    return null
  }
}

export const getLoginUserDeviceIds = (state: State): string[] => {
  const user = getLoginUser(state)

  if (!user) return []
  return _.keys(user.deviceIds) || []
}
export const getLoginUserTitle = (state: State): string => {
  const user = getLoginUser(state)

  if (!user) return '現場'
  return user.title || '現場'
}

export const getIsLogin = (state: State) =>
  !state.Auth.loading && state.Auth.authorized
